module.exports = "https://coursera_assets.s3.amazonaws.com/images/ee63273663b9a29ff72bd2df996aa5f5.png";